const HealthSafetyPolicy = {
    title: "New Health & Safety Policy",
};
export default HealthSafetyPolicy;
